import React from 'react';

import { FreightForwarderContext, ThemeContext } from './index';
import { withFirebase } from '../Firebase';
import { withTheme } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';

const withFreightForwarder = (Component) => {
  class WithFreightForwarder extends React.Component {
    constructor(props) {
      super(props);

      this.updateFreightForwarder = (currentFreightForwarder) => {
        this.setState({ currentFreightForwarder });
      };

      this.state = {
        currentFreightForwarder: null,
        updateFreightForwarder: this.updateFreightForwarder,
        loadChargeCodes: this.loadChargeCodes,
        containers: [],
      };
    }

    componentDidMount() {
      this.loadFreightForwarder();
      this.loadContainers();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.freight_forwarder_id !== this.props.freight_forwarder_id) {
        /* setting currentFreightForwarder to null will breifly remove the route
                displayed and then re-display it after loadFreightForwarder has returned.
                This ensure the displayed page is re-initialiased and the appropriate
                freight forwarder information is shown
                */
        this.setState({ currentFreightForwarder: null }, this.loadFreightForwarder);
      }
    }

    loadFreightForwarder() {
      if (this.props.freight_forwarder_id) {
        this.props.firebase.freightForwarder(this.props.freight_forwarder_id).then((currentFreightForwarder) => {
          this.loadChargeCodes();
          this.setState({ currentFreightForwarder });
          if (currentFreightForwarder.primaryColor) {
            this.context.updateTheme({
              ...this.props.theme,
              palette: {
                ...this.props.theme.palette,
                primary: {
                  ...this.props.theme.palette.primary,
                  main: currentFreightForwarder.primaryColor,
                  dark: darken(currentFreightForwarder.primaryColor, 0.2),
                  darker: darken(currentFreightForwarder.primaryColor, 0.4),
                  light: lighten(currentFreightForwarder.primaryColor, 0.2),
                  lighter: lighten(currentFreightForwarder.primaryColor, 0.9),
                },
              },
              overrides: {
                ...this.props.theme.overrides,
                MuiTablePagination: {
                  root: {
                    color: currentFreightForwarder.primaryColor,
                  },
                },
              },
            });
          } else {
            this.context.useDefaultTheme();
          }
        });
      }
    }

    loadChargeCodes = () => {
      let { firebase, freight_forwarder_id } = this.props;
      return firebase
        .getAllRecursive('chargeCodes', { freight_forwarder_id }, { itemsPerPage: 200, currentPage: 1 })
        .then((chargeCodes) => {
          this.setState({ chargeCodes });
        });
    };

    loadContainers = () => {
      return this.props.firebase.getAllRecursive('containers').then((containers) => this.setState({ containers }));
    };

    componentWillUnmount() {
      // this.listener();
    }

    render() {
      let { currentFreightForwarder, chargeCodes } = this.state;
      return this.state.currentFreightForwarder ? (
        <FreightForwarderContext.Provider value={this.state}>
          <Component
            {...this.props}
            currentFreightForwarder={currentFreightForwarder}
            chargeCodes={chargeCodes}
            loadChargeCodes={this.loadChargeCodes}
          />
        </FreightForwarderContext.Provider>
      ) : null;
    }
  }

  WithFreightForwarder.contextType = ThemeContext;

  return compose(withFirebase, withTheme)(WithFreightForwarder);
};

export default withFreightForwarder;
